var _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.52,14.45v-.81a8.43,8.43,0,0,0-1.12-.47l-.2-.46a8.83,8.83,0,0,0,.43-1.09L18,11a10.75,10.75,0,0,0-1.09.43l-.46-.19a7.14,7.14,0,0,0-.5-1.05h-.9s-.42,1.09-.42,1.09l-.51.19A9.29,9.29,0,0,0,13,11l-.58.58a5.13,5.13,0,0,0,.42,1.09l-.19.46s-1.09.43-1.09.47v.85a6.4,6.4,0,0,0,1.09.47l.19.46a8.8,8.8,0,0,0-.42,1.09l.62.62a8.68,8.68,0,0,0,1.08-.43l.51.2a6.17,6.17,0,0,0,.5,1H16a6.32,6.32,0,0,0,.47-1.08l.5-.2a9.45,9.45,0,0,0,1.13.43l.62-.62a8.94,8.94,0,0,0-.47-1.09l.2-.46S19.52,14.49,19.52,14.45Zm-4,1.09A1.48,1.48,0,1,1,17,14.07,1.47,1.47,0,0,1,15.53,15.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.05,8.62a7.85,7.85,0,0,1,.68,1.4l0,0,.61.25a11.21,11.21,0,0,1,1.47-.57l.83.83a6.05,6.05,0,0,1-.41,1.11l.77.49V2.06L15.38,4.53V8.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.87,12a7.26,7.26,0,0,1-.58-1.47l.79-.78a13.66,13.66,0,0,1,1.52.57l.68-.26s.39-1.11.53-1.4V4.74a2.52,2.52,0,0,0-2.52-2.52H2.52A2.52,2.52,0,0,0,0,4.74V9.81a2.52,2.52,0,0,0,2.52,2.51h9.22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.14,
    y: 5.25,
    width: 2.02,
    height: 3.37
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSettings);
export default __webpack_public_path__ + "static/media/camera-settings.6f3c073af1837988f0a0ab165353de00.svg";
export { ForwardRef as ReactComponent };